import axios from 'axios'
//import config from '../config/index' // 路径配置
//- 环境变量
//axios.defaults.withCredentials = true;
window.Global= {
  env: process.env.VUE_APP_BASE_API
};
// 创建axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,//config.baseURL, // api的base_url
    timeout: 10000 // 请求超时时间
})

// request 拦截器
service.interceptors.request.use(
    config => {
        config.headers.accessTokenWap = localStorage.getItem('token');  //dd 
       // config.headers.Content-Range:'btyes 0-1'
        //、Accept-Ranges:bytes、'Content-Length: 123456789'，'Content-Type: video/mp4'
        // 这里可以自定义一些config 配置
        // config.headers.token = '110';   
        // config.headers.set('Content-Range', '0-1'); 
        // config.headers.set('Accept-Ranges', 'bytes'); 
        // config.headers.set('Content-Length', '123456789'); 
        // config.headers.set('Content-Type', 'video/mp4'); 
        // config.headers['Content-Range'] = 1;
        // config.headers['Accept-Ranges'] = 'bytes'
        // config.headers['Content-Length'] = '123456789'
        // config.headers['Content-Type'] = 'video/mp4'
        return config
    },
    error => {
        //  这里处理一些请求出错的情况

        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        // 这里处理一些response 正常放回时的逻辑

        return res
    },
    error => {
        // 这里处理一些response 出错时的逻辑

        return Promise.reject(error)
    }
)

export default service